





















































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { freightLooks } from "@/utils/api";

@Component
export default class freightLook extends Vue {
  lookData: object={};
  tableData: Array<object>=[]//表格数据
  name: string='';//创建人
  time: number=0;//时间
  typeName: string='按件数';
  @Prop(Object) looksData:object|undefined;
  @Watch('looksData', { immediate: true, deep: true })
  onPersonChanged1(val: Object) {
    let id=val['templateId'];
    this.freightLooks(id);
  }
  freightLooks(templateId){
    freightLooks({templateId}).then((data:any)=>{
      this.lookData=data;
      this.tableData=data.templateList;
      let templateType=data.templateType;
      this.name=data.templateList[0].createdBy.fullName;
      this.time=data.templateList[0].createdDate;
      if(templateType==0){
        this.typeName='按件数';
      }else if(templateType==1){
        this.typeName='按重量';
      }else{
        this.typeName='按体积';
      }
    })
  }
}
